import React from 'react'

export default function CalendarDisabledIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='57'
      height='63'
      viewBox='0 0 57 63'
      fill='none'
      {...props}
    >
      <path
        d='M21.3125 52.4375L16.9375 48.0625L24.125 40.875L16.9375 33.6875L21.3125 29.3125L28.5 36.5L35.6875 29.3125L40.0625 33.6875L32.875 40.875L40.0625 48.0625L35.6875 52.4375L28.5 45.25L21.3125 52.4375ZM6.625 62.75C4.90625 62.75 3.4349 62.138 2.21094 60.9141C0.986979 59.6901 0.375 58.2188 0.375 56.5V12.75C0.375 11.0312 0.986979 9.5599 2.21094 8.33594C3.4349 7.11198 4.90625 6.5 6.625 6.5H9.75V0.25H16V6.5H41V0.25H47.25V6.5H50.375C52.0938 6.5 53.5651 7.11198 54.7891 8.33594C56.013 9.5599 56.625 11.0312 56.625 12.75V56.5C56.625 58.2188 56.013 59.6901 54.7891 60.9141C53.5651 62.138 52.0938 62.75 50.375 62.75H6.625ZM6.625 56.5H50.375V25.25H6.625V56.5Z'
        fill='currentColor'
      />
    </svg>
  )
}
